/* Built in imports */
import React from 'react';

/* Internal imports */
import AccesApporteurPage from '../../pages/public_pages/AccesApporteurPage';
import AppRoute from '../../helpers/routes/AppRoute';
import Home from '../../components/yes/home/Home';
import StaticSiteLayout from '../../layouts/default/StaticSiteLayout';
import VersionViewer from '../../pages/public_pages/versionViewer/VersionViewer';
import {
  ROUTE_ACCES_CONTRIBUTEUR,
  ROUTE_ACCUEIL_GALAXY,
  ROUTE_HOME,
  ROUTE_DOSSIERS_GALAXY,
  ROUTE_VERSION_VIEWER
} from '../../common/Configuration';

const getRoutesAuthentification = () => {
  return [
    <AppRoute key={ROUTE_ACCES_CONTRIBUTEUR} exact path={ROUTE_ACCES_CONTRIBUTEUR} component={AccesApporteurPage} />,
    <AppRoute key={ROUTE_VERSION_VIEWER} exact path={ROUTE_VERSION_VIEWER} component={VersionViewer} />
  ];
};

const PublicRoutesDefault = () => {
  return[
      <AppRoute key={ROUTE_HOME} exact path={ROUTE_HOME} layout={StaticSiteLayout} component={Home} />,
      <AppRoute key={ROUTE_ACCUEIL_GALAXY} exact path={ROUTE_ACCUEIL_GALAXY} component={() => {
          window.location.replace(process.env.REACT_APP_STATIC_URL + ROUTE_ACCUEIL_GALAXY);
          return null;
        }
      } />,
      <AppRoute key={ROUTE_DOSSIERS_GALAXY} exact path={ROUTE_DOSSIERS_GALAXY} component={() => {
          window.location.replace(process.env.REACT_APP_STATIC_URL + ROUTE_DOSSIERS_GALAXY);
          return null;
        }
      } />
    ].concat(getRoutesAuthentification());
}

export default PublicRoutesDefault();
